<template>
  <section class="grow-together">
      <div class="grow-together__content">
        <div class="grow-together__text container">
          <h3 class="grow-together__subtitle --fade-in-up" data-ivp-class="--animate">WE GROW TOGETHER</h3>
          <h1 class="grow-together__title">From cultivation to dispensaries, we have local cannabis covered.</h1>
          <h2 class="grow-together__data"><b>Our Team's Collective Achievements</b></h2>
          <h2 class="grow-together__data"><b>300+ Franchises</b> Award in More than 15 Countries</h2>
          <h2 class="grow-together__data"><b>45+</b> Cannabis & Franchise Industry <b>Awards</b></h2>
          <h2 class="grow-together__data"><b>17 States</b> We've Won Cannabis Licenses</h2>
        </div>
        <div class="grow-together__about-cards --fade-in-up" data-ivp-class="--animate">
            <div class="grow-together__single-card">
                <img src="../assets/grow-together/item9-1.jpeg">
                <div class="grow-together__overlay">
                    <div class="grow-together__overlay-content">
                        <h1>Item 9 Labs Corp.</h1>
                        <p>(OTCQX: INLB) is a vertically integrated cannabis franchisor and
                            operator that produces high-grade, award-winning products.</p>
                    </div>
                </div>
            </div>
            <div class="grow-together__single-card">
                <img src="../assets/grow-together/item9-2.jpeg">
                <div class="grow-together__overlay">
                    <div class="grow-together__overlay-content">
                        <h1>Item 9 Labs</h1>
                        <p>Cultivates award-winning elevated mainstream cannabis flower,
                            vape cartridges, concentrates and Orion vape technologies.</p>
                    </div>
                </div>
            </div>
            <div class="grow-together__single-card">
                <img src="../assets/grow-together/item9-3.png">
                <div class="grow-together__overlay">
                    <div class="grow-together__overlay-content">
                        <h1>Unity Rd.</h1>
                        <p>The first national cannabis dispensary franchise model in the
                            United States – offering one of the safest routes for entrepreneurs.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GrowTogether',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/GrowTogether.scss";
</style>
